module.exports = __webpack_public_path__ + "static/img/bg.0288f50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/bg.jpg
// module id = QxXo
// module chunks = 1